module.exports = __webpack_public_path__ + "static/media/chair_grey.58700c4b.png";